import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M16 12c0 .234-.1.457-.273.611l-6.4 5.688a.79.79 0 0 1-1.129-.076.82.82 0 0 1 .075-1.147L13.985 12 8.273 6.924a.82.82 0 0 1-.075-1.147.79.79 0 0 1 1.129-.076l6.4 5.688A.82.82 0 0 1 16 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-right-direction"}) } }